module.exports = __webpack_public_path__ + "static/media/ScalingSideProjects.73cb6a0e.png";